import type { ComponentCommonDays } from '@edwin-group/cj-graphql/generated/graphql';

export const hasDatePassed = (day: ComponentCommonDays) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const startDate = new Date(day.startDate);
  startDate.setHours(0, 0, 0, 0);

  if (day.wholeMonth) {
    const endOfMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    return today > endOfMonth;
  }

  if (day.endDate) {
    const endDate = new Date(day.endDate);
    endDate.setHours(0, 0, 0, 0);
    return today > endDate;
  }

  return today > startDate;
};
